const getStringWidth = function (text) {
  // Create a temporary span element
  const element = document.createElement('span');
  // Set the text
  element.textContent = text;
  // Ensure the element is not visible in the document
  element.style.visibility = 'hidden';
  // Append it to the body to make its dimensions measurable
  document.body.appendChild(element);
  // Measure the text width
  const width = element.offsetWidth;
  // Clean up by removing the element from the document
  document.body.removeChild(element);
  return width;
}

/**
 * Resets the sample form to its initial state. This involves showing and hiding
 * various form components and removing custom input fields.
 */
const resetSample = function () {
  const $sample = $('.sample-container');
  const $select = $sample.find('.edit-tag-cont select');
  $sample.find('.edit-tag-cont .form-control-group').hide();
  $sample.find('.form-component').show();
  $sample.find('.form-control-custom').remove();
  $select.removeClass('d-none');
}

/**
 * Handles clicks on form components, setting up the correct input method (input or select)
 * and focusing the input for user interaction.
 *
 * @param {jQuery} $this - The jQuery object representing the clicked form component.
 */
const handleFormComponentClick = function ($this) {
  const $sample = $this.closest('.sample-container');
  const $container = $this.closest('.edit-tag-cont');
  const $inputGroup = $container.find('.form-control-group');
  const $input = $inputGroup.find('.form-element');
  const rect = $this[0].getBoundingClientRect();
  const value = $input.val();
  const text = $this.text();

  // Hide all
  $sample.find('.edit-tag-cont .form-control-group').hide();
  $sample.find('.form-component').show();

  // Show current
  $inputGroup.show();
  $this.hide();
  $input.focus();

  if ($input[0].tagName === 'INPUT') {
    const width = getStringWidth(text);
    $input.attr('placeholder', `i.e., ${$this.data('placeholder')}`);
    $input.css({'min-width': `${width}px`});
  }
  if ($input[0].tagName === 'SELECT') {
    if (value === 'custom') {
      const $customInput = handleCustomSelection($input);
      $customInput.val(text);
    }
  }
}

/**
 * Handles the selection of a 'custom' option in a select dropdown, creating
 * a new input field for custom input.
 *
 * @param {jQuery} $this - The jQuery object representing the select element.
 * @returns {jQuery} The jQuery object representing the newly created custom input field.
 */
const handleCustomSelection = function ($this) {
  const app = PreBuilt;
  const $container = $this.closest('.edit-tag-cont');
  const $inputGroup = $container.find('.form-control-group');
  const custom = _.template(app.templates['global__dynamic-learn-custom']);
  const $custom = $(custom({'placeholder': `i.e., enter custom value`}));
  const $closeButton = $('.btn-close-custom', $container);

  $container.addClass('invalid');
  $this.addClass('d-none');
  $closeButton.hide();
  $custom.appendTo($inputGroup);
  const $customInput = $custom.find('input')
  $customInput.focus();
  return $customInput;
}

/**
 * Resets the select element to its default state and updates the associated form component
 * display value.
 *
 * @param {jQuery} $container - The jQuery object representing the container of the select element.
 */
const resetSelect = function ($container) {
  const $select = $container.find('select');
  const $inputGroup = $container.find('.form-control-group');
  const $formComponent = $('.form-component', $container);
  let value = $select.val();
  if (value === 'custom') {
    $select.find('option:eq(0)').prop('selected', true);
    value = $select.val();
  }
  $select.removeClass('d-none');
  $container.addClass('invalid');
  $formComponent.text(value);
}

const setFormComponentText = function ($formComponent, value) {
  $formComponent.text(value);
  updateCharacterCount();
  const $sample = $formComponent.closest('[data-sample]');
  const sampleObject = new Sample($sample);
  sampleObject.validate();
}
/**
 * Handles the blur event on custom input elements, updating the form component display
 * with the entered value or resetting the select element as needed.
 *
 * @param {jQuery} $this - The jQuery object representing the custom input element.
 */
const handleCustomInputBlur = function ($this) {
  const $container = $this.closest('.edit-tag-cont');
  const $inputGroup = $container.find('.form-control-group');
  const $formElement = $inputGroup.find('.form-element');
  const $formComponent = $('.form-component', $container);
  const value = $this.val();
  const $custom = $('.form-control-custom', $container);
  if (value.trim() !== '') {
    $container.removeClass('invalid');
    setFormComponentText($formComponent, value);
    $formElement.attr('data-custom-value', value);
    setTimeout(function () {
      $container.find('.btn-close-custom').show();
    }, 500);
  } else {
    resetSelect($container);
  }
  $inputGroup.hide();
  $formComponent.show();
  $custom.remove();
}

const handleInputBlur = function ($this) {
  const $container = $this.closest('.edit-tag-cont');
  const $inputGroup = $container.find('.form-control-group');
  const $formComponent = $('.form-component', $container);
  const value = $this.val();

  if (value.trim() !== '') {
    $container.removeClass('invalid');
    setFormComponentText($formComponent, value);
  } else {
    $container.addClass('invalid');
    setFormComponentText($formComponent, $formComponent.data('original'));
  }

  $inputGroup.hide();
  $formComponent.show();
}

const updateCharacterCount = function () {
  const $sampleContainer = aimi_samples.getSampleContainer();
  if ($sampleContainer === null) return false;
  const $staticTextCont = $('.static-text-cont', $sampleContainer);
  const $editableTextCont = $('[data-edit]', $sampleContainer);
  const $charCount = $('[data-character-count]', $sampleContainer.closest('.samples-container'));
  let count = 0;

  $editableTextCont.each(function () {
    count += $.trim($(this).text()).length;
  });

  $staticTextCont.each(function () {
    count += $.trim($(this).text()).length;
  });

  $charCount.text(count);
}

class Sample {
  constructor(container) {
    this.container = container;
  }

  getData() {
    let data = [];
    this.container.find('.edit-tag-cont:not(.invalid) [data-tag]').each(function () {
      const $this = $(this);
      const $tag = $this.attr('data-tag');
      const elementType = $this[0].type;
      let value = $this.val();
      if (value === 'custom') {
        value = $this.data('custom-value');
      }
      data.push({tag: $tag, value: value});
    });
    return data;
  }

  validate() {
    const invalids = this.container.find('.edit-tag-cont.invalid');
    const sampleNav = $(`[data-bs-target="#${this.container.attr('id')}"]`);
    sampleNav.removeClass('invalid valid');
    if (invalids.length) {
      sampleNav.addClass('invalid');
    } else {
      sampleNav.addClass('valid');
    }
    return !invalids.length;
  }

  /**
   * return string
   */
  getSampleType() {
    return this.container.attr('id').indexOf('under280') >= 0 ? 'under280' : 'over280';
  }

  static setElementValue($this, value) {
    if ($this[0].tagName === 'INPUT') {
      $this.val(value);
      if ($this.hasClass('form-element-custom')) {
        handleCustomInputBlur($this);
      } else {
        handleInputBlur($this);
      }
    }
    if ($this[0].tagName === 'SELECT') {
      const orgValue = value;

      const $container = $this.closest('.edit-tag-cont');
      const $formComponent = $('.form-component', $container);

      if (!Utils.doesOptionExist($this, value)) {
        value = 'custom';
      }

      $this.val(value);

      if (value !== 'custom') {
        $container.removeClass('invalid');
        setFormComponentText($formComponent, value);
        resetSample();
      }
      if (value === 'custom') {
        const $customInput = handleCustomSelection($this);
        $customInput.val(orgValue);
        handleCustomInputBlur($customInput);
      }
    }
  }

  static createInputField(mergeTag) {
    mergeTag.cta = mergeTag.cta || false;
    const app = PreBuilt;
    let $__input = app.templates['global__dynamic-learn-input'];
    let input = _.template($__input);

    return $(input(mergeTag));
  }

  static createSelectField(mergeTag) {
    mergeTag.cta = mergeTag.cta || false;
    const app = PreBuilt;
    let $option;
    let $__select = app.templates['global__dynamic-learn-select'];
    let select = _.template($__select);
    let $select = $(select(mergeTag));
    let options = mergeTag.options.split(',');
    $.each(options, function (index, value) {
      value = $.trim(value);
      $option = $('<option />').attr('value', value).text(value);
      $select.find('select').append($option);
    });

    return $select;
  }

  /**
   * Parses a sample text string, replacing specific placeholders with HTML elements according to provided options and campaign-specific configurations.
   * This function operates by first adjusting the options into a key-value mapping for easy lookup. It then splits the sample text by placeholders,
   * identifying each through a regular expression. For each placeholder found, it checks against the options to determine if it should be skipped
   * (not replaced). If not skipped and defined in the campaign options, it generates the corresponding HTML element based on the type specified
   * (e.g., input or select). Placeholders not matching any campaign option or marked to be skipped are removed from the sample. Static text
   * outside of placeholders is wrapped in a span element for consistent handling.
   *
   * @param {string} sample - The string containing the text and placeholders to be parsed.
   * @param {Object} optionValues - An array of objects, where each object has a `tag` property representing the placeholder, and a `value` property indicating whether the tag should be replaced.
   * @param {Object} campaignOptions - An object with properties corresponding to placeholders. Each property's value is an object that describes how to replace that placeholder, including the type of HTML element to generate.
   * @returns {string[]} An array where each element is either a static piece of text wrapped in HTML or a generated HTML element string replacing a placeholder. This allows for further manipulation or direct insertion into the DOM.
   */
  static parseSample (sample, optionValues, campaignOptions) {
    let __view = this, $el, skip, tmp = {};
    optionValues.forEach(row => tmp[row.tag] = row.value);
    optionValues = tmp;
    sample = sample.split(/({.*?\|})/gm);

    $.each(sample, function (index, value) {
      if (value.indexOf('|}') > -1) {

        skip = typeof optionValues[value] !== 'undefined' && !optionValues[value]

        if (typeof campaignOptions[value] != 'undefined' && !skip) {
          let mergeTag = campaignOptions[value];

          switch (mergeTag.type) {
            case 'input':
              $el = Sample.createInputField(mergeTag);
              break;
            case 'select':
              $el = Sample.createSelectField(mergeTag);
              break;

            default:
              $el = $('<div class="edit-tag-cont invalid" />').text(value)[0].outerHTML;
              break;
          }
          sample[index] = $el[0].outerHTML;
        } else {
          sample[index] = '';
        }
      } else {
        sample[index] = $('<span class="static-text-cont" />').text(value)[0].outerHTML;
      }
    });

    return sample;
  }
}


const getSamplesData =  (mergeTags) => {
  const app = PreBuilt;

  const indexByTag = function (options) {
    let tmp = {};
    options.forEach(function (value, index, array) {
      if (!app.isEmpty(value.tag)) {
        tmp[value.tag] = value;
      }
    });

    return tmp;
  }

  const findByKey = function (arry, key) {
    let keyValue = null;
    _.each(arry, function (value) {
      if (!_.isUndefined(value[key])) {
        keyValue = value[key];
      }
    });

    return keyValue;
  }

  let groupedMergeTags = {over280: [], under280: []};

  _.each(mergeTags, function (mergeTag) {
    let index = findByKey(mergeTag, '###index###'),
        twitter = findByKey(mergeTag, '###twitter###');
    const tags = indexByTag(mergeTag);
    if (twitter) {
      groupedMergeTags['under280'].push(tags);
    } else {
      groupedMergeTags['over280'].push(tags);
    }
  });

  return groupedMergeTags;
}


/**
 * A module for handling sample interactions within a dynamic form.
 * Allows for the dynamic selection, editing, and input of form components
 * within a sample container.
 *
 * @module aimi_samples
 * @param {Object} aimi_samples - The main object to hold the module's public functions.
 * @param {jQuery} $ - The jQuery library object.
 * @param {Object} app - An application object that provides context and additional functionality.
 * @param {undefined} undefined - An explicit undefined parameter for safety checks.
 */
(function (aimi_samples, $, app, undefined) {

  let __this = {
    $sampleContainer: null
  };

  aimi_samples.setSampleContainer = function ($container) {
    __this.$sampleContainer = $container;
    updateCharacterCount();
  }

  aimi_samples.getSampleContainer = function ($container) {
    return __this.$sampleContainer;
  }
  /**
   * Initializes event listeners for form components within the sample container.
   * This includes handling clicks, blurs, changes, and keyboard events to enable
   * dynamic interaction with the form.
   */
  aimi_samples.init = function () {
    /**
     * Initializes event bindings for dynamic form interactions.
     *
     * This setup includes handling user interactions such as clicks, blurs, changes, paste actions,
     * and keydown events. It ensures that form components respond appropriately to user inputs,
     * supporting a dynamic and interactive experience.
     */

    /**
     * Event binding for clicking on form components.
     * Delegates click events to `.form-component` elements, triggering the `handleFormComponentClick` function.
     */
    $(document).off('click.bf_form_component').on('click.bf_form_component', '.form-component', function (e) {
      const $this = $(this);
      handleFormComponentClick($this);
    });

    /**
     * Event binding for handling blur events on select elements within `.edit-tag-cont`.
     * Triggers when the select element loses focus, checking for non-custom values to update the UI and reset form samples.
     */
    $(document).off('blur.bf_select_component').on('blur.bf_select_component', '.edit-tag-cont select', function (e) {
      const $this = $(this);
      const $container = $this.closest('.edit-tag-cont');
      const $formComponent = $('.form-component', $container);
      const value = $this.val();

      if (value !== 'custom') {
        $container.removeClass('invalid');
        setFormComponentText($formComponent, value);
        resetSample();
      }
    });

    /**
     * Event binding for change events on select elements within `.edit-tag-cont`.
     * Handles the selection of 'custom' option, enabling a custom input field for user input.
     */
    $(document).off('change.bf_select_component').on('change.bf_select_component', '.edit-tag-cont select', function (e) {
      const $this = $(this);
      const $container = $this.closest('.edit-tag-cont');
      const $formComponent = $('.form-component', $container);
      const value = $this.val();

      if (value === 'custom') {
        handleCustomSelection($this);
      }
    });

    /**
     * Event binding for blur events on custom input elements.
     * Ensures that custom inputs are validated and processed when they lose focus.
     */
    $(document).off('blur.form-element-custom').on('blur.form-element-custom', '.form-element-custom, .form-element-input', function (e) {
      const $this = $(this);
      if ($this.hasClass('form-element-custom')) {
        handleCustomInputBlur($this);
      } else {
        handleInputBlur($this);
      }
    });

    /**
     * Event binding for paste events on custom input elements.
     * Handles paste actions to immediately validate and process the pasted content.
     */
    $(document).off('paste.form-element-custom').on('paste.form-element-custom', '.form-element-custom, .form-element-input', function (e) {
      const $this = $(this);
      if ($this.hasClass('form-element-custom')) {
        handleCustomInputBlur($this);
      } else {
        handleInputBlur($this);
      }
    });

    /**
     * Event binding for handling the "Enter" keydown event on custom input elements.
     * Processes the input immediately when the Enter key is pressed.
     */
    $(document).off('keydown.form-element-custom').on('keydown.form-element-custom', '.form-element-custom, .form-element-input', function (e) {
      if (e.key === "Enter" || e.which === 13) {
        const $this = $(this);
        if ($this.hasClass('form-element-custom')) {
          handleCustomInputBlur($this);
        } else {
          handleInputBlur($this);
        }
      }
    });

    /**
     * Global keydown event binding for handling the "Escape" key, targeting the document's body.
     * Facilitates a quick escape mechanism for closing or resetting form components.
     */
    $(document).off('keydown.sample-container').on('keydown.sample-container', 'body', function (e) {
      if (e.key === "Escape" || e.keyCode === 27) { // event.keyCode === 27 for older browsers
        const $this = $(this);
        const $select = $('.edit-tag-cont select');
        const $custom = $('.form-element-custom');
        const $input = $('.form-element-input');
        if ($select.is(":visible")) {
          $select.trigger('blur.bf_select_component');
        }
        if ($custom.is(":visible")) {
          $custom.trigger('blur.form-element-custom');
        }
        if ($input.is(":visible")) {
          $input.trigger('blur.form-element-input');
        }
      }
    });

    /**
     * Event binding for handling clicks on the custom close button within a form component.
     * Resets the form component and select elements to their initial states.
     */
    $(document).off('click.btn-close-custom').on('click.btn-close-custom', '.btn-close-custom', function (e) {
      const $this = $(this);
      const $container = $this.closest('.edit-tag-cont');
      const $formComponent = $('.form-component', $container);
      $this.hide();
      resetSample();
      resetSelect($container);
      handleFormComponentClick($formComponent);
    });
  }
}(window.aimi_samples = window.aimi_samples || {}, jQuery, PreBuilt));
